import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog";

// Reusable destructive-action confirmation (reset traffic / clear registrations).
export const ConfirmDangerDialog = ({
  trigger,
  title,
  description,
  confirmLabel,
  onConfirm,
  dialogTestId,
  cancelTestId,
  confirmTestId,
}) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
    <AlertDialogContent data-testid={dialogTestId}>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={cancelTestId}>Cancel</AlertDialogCancel>
        <AlertDialogAction
          data-testid={confirmTestId}
          onClick={onConfirm}
          className="bg-[#c0392b] hover:bg-[#a93226] focus:ring-[#c0392b]"
        >
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
